/* Pay-methods inline row
   Pulls the Klarna on-site-messaging placement up onto the same line as the Shop
   Pay instalment message, so it reads:
     "Pay in 3 interest-free instalments of £X with Shop or Klarna"
   Only the Klarna badge (its pink logo) is shown — its own price message is
   hidden by pay-methods-inline.css, since the amount is already stated by the
   Shop Pay line.

   Both widgets are third-party and region-gated, so this no-ops cleanly when
   either is absent. Styling lives in pay-methods-inline.css. */

(function () {
  // product-information.liquid is rendered by main-product, featured-product and
  // quick-view, so this file can load more than once per page — only run once.
  if (window.payMethodsInlineLoaded) return;
  window.payMethodsInlineLoaded = true;

  var supportsHas = window.CSS && CSS.supports && CSS.supports("selector(:has(*))");

  // Move the Klarna placement next to the Shop Pay terms, with an "or" between them.
  function arrange() {
    var terms = document.querySelector("shopify-payment-terms");
    var klarna = document.querySelector("klarna-placement");
    if (!terms || !klarna) return false;

    var row = terms.closest("form.installment") || terms.parentElement;
    if (!row) return false;
    row.classList.add("pay-methods-inline");

    var sep = row.querySelector(".pay-methods-inline__or");
    if (!sep) {
      sep = document.createElement("span");
      sep.className = "pay-methods-inline__or";
      sep.textContent = "or";
      terms.insertAdjacentElement("afterend", sep);
    }

    if (klarna.previousElementSibling !== sep) {
      var originalParent = klarna.parentElement;
      sep.insertAdjacentElement("afterend", klarna);
      // The wrapper is normally collapsed by the :not(:has(klarna-placement))
      // rule in the stylesheet; fall back to an inline hide only where :has() is
      // unsupported. It still holds Klarna's registration <script>, which keeps
      // running under display:none, so check for leftover *visual* children
      // rather than textContent.
      if (originalParent && !supportsHas) {
        var hasVisual = Array.prototype.some.call(originalParent.children, function (c) {
          return ["SCRIPT", "STYLE", "LINK", "TEMPLATE"].indexOf(c.tagName) === -1;
        });
        if (!hasVisual) originalParent.style.display = "none";
      }
    }
    return true;
  }

  function apply() {
    var done = arrange();
    var klarna = document.querySelector("klarna-placement");
    if (klarna && klarna.shadowRoot) {
      var textWrapper = klarna.shadowRoot.querySelector(".text-wrapper");
      if (textWrapper) textWrapper.style.marginLeft = "0";
    }
    return done;
  }

  function start() {
    apply();
    // Poll while the two third-party widgets load in.
    var interval = setInterval(function () {
      if (apply()) clearInterval(interval);
    }, 300);
    // Stop polling if the widgets never appear (region-gated, or below Klarna's minimum).
    setTimeout(function () {
      clearInterval(interval);
    }, 15000);

    /* Variant changes re-render this section (and Klarna re-injects its
       placement), which would otherwise drop the arrangement — re-apply on any
       DOM change. This must observe document.body, not
       .product-information--inner: the re-render replaces that container, which
       would leave the observer bound to a detached node and silently stop firing
       after the first variant switch. apply() is idempotent, so re-entry from
       our own mutation settles immediately. */
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        apply();
      });
    }).observe(document.body, { childList: true, subtree: true });

    /* A change event fires before the re-render it triggers has landed, so the
       state read at that instant is the outgoing one — re-check as the new
       markup arrives. */
    document.addEventListener(
      "change",
      function () {
        apply();
        [400, 1200, 2500].forEach(function (delay) {
          setTimeout(apply, delay);
        });
      },
      true
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
